// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"286ff67c","551":"3ec632b0","842":"d04e741f"}[chunkId] + ".chunk.js";
};